import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { IconThumbsUp, IconThumbsDown, IconClose } from '@edulastic/icons'
import { THUMB_COLORS } from './constants'

const BANNER_COPY = 'Were these search results helpful?'

const SearchSatisfactionBanner = ({
  activeVote,
  onThumbsUp,
  onThumbsDown,
  onDismiss,
}) => (
  <BannerWrapper data-cy="searchSatisfactionBanner">
    <CenterContent>
      <BannerText>{BANNER_COPY}</BannerText>
      <ThumbsGroup>
        <ThumbButton
          type="button"
          data-cy="searchSatisfactionThumbsUp"
          aria-label="Search results helpful, thumbs up"
          onClick={onThumbsUp}
          $active={activeVote === 'up'}
          $activeColor={THUMB_COLORS.upActive}
        >
          <IconThumbsUp />
        </ThumbButton>
        <ThumbButton
          type="button"
          data-cy="searchSatisfactionThumbsDown"
          aria-label="Search results not helpful, thumbs down"
          onClick={onThumbsDown}
          $active={activeVote === 'down'}
          $activeColor={THUMB_COLORS.downActive}
        >
          <IconThumbsDown />
        </ThumbButton>
      </ThumbsGroup>
    </CenterContent>
    <DismissButton
      type="button"
      data-cy="searchSatisfactionDismiss"
      aria-label="Dismiss search satisfaction prompt"
      onClick={onDismiss}
    >
      <IconClose />
    </DismissButton>
  </BannerWrapper>
)

SearchSatisfactionBanner.propTypes = {
  activeVote: PropTypes.oneOf(['up', 'down', null]),
  onThumbsUp: PropTypes.func.isRequired,
  onThumbsDown: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
}

SearchSatisfactionBanner.defaultProps = {
  activeVote: null,
}

export default SearchSatisfactionBanner

const BannerWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 16px 0;
  padding: 12px 48px 12px 16px;
  background: #f9fbfc;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  box-sizing: border-box;
`

const CenterContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
`

const BannerText = styled.p`
  margin: 0;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #2f4151;
  text-align: center;
`

const ThumbsGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const ThumbButton = styled.button`
  width: 28px;
  height: 28px;
  border: 1px solid
    ${({ $active, $activeColor }) =>
      $active ? $activeColor : THUMB_COLORS.border};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: ${({ $active, $activeColor }) =>
    $active ? $activeColor : '#fff'};
  padding: 0;

  svg {
    fill: ${({ $active }) => ($active ? '#fff' : THUMB_COLORS.inactive)};
  }

  &:hover {
    border-color: ${({ $activeColor }) =>
      $activeColor || THUMB_COLORS.upActive};
  }
`

const DismissButton = styled.button`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  svg {
    fill: #7a7a7a;
  }

  &:hover svg {
    fill: #2f4151;
  }
`
